function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.67242 11.0014C4.87001 11.0014 5.66696 10.2437 5.66696 9.10524L5.66117 8.50711C5.66117 8.50711 5.36467 6.81174 7.74394 6.81174L17.3782 6.87499V9.29361C17.6031 9.50605 17.9073 9.62527 18.2243 9.62527C18.5414 9.62527 18.8455 9.50605 19.0704 9.29361L22.7919 5.75711C23.0154 5.5433 23.1408 5.25414 23.1408 4.95274C23.1408 4.65134 23.0154 4.36217 22.7919 4.14836L19.0704 0.401486C18.8455 0.189053 18.5414 0.0698242 18.2243 0.0698242C17.9073 0.0698242 17.6031 0.189053 17.3782 0.401486V2.93836C17.1453 2.87374 8.04479 2.83661 8.04479 2.83661C2.67732 2.83661 1.50287 6.17649 1.50287 7.52124V8.93886C1.50287 9.48587 1.73145 10.0105 2.13832 10.3973C2.54518 10.7841 3.09702 11.0014 3.67242 11.0014Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.9725 11.0577C19.7749 11.0577 18.803 11.8607 18.803 12.9992L18.8059 14.3151C18.7408 14.806 17.873 15.1264 16.6002 15.1264H7.14237L7.13948 12.9827C6.91457 12.7703 6.6104 12.6511 6.29335 12.6511C5.97631 12.6511 5.67213 12.7703 5.44723 12.9827L1.72717 16.5192C1.50371 16.733 1.3783 17.0222 1.3783 17.3236C1.3783 17.625 1.50371 17.9142 1.72717 18.128L5.44723 21.6645C5.55821 21.7703 5.69009 21.8543 5.83528 21.9116C5.98048 21.9689 6.13614 21.9984 6.29335 21.9984C6.45056 21.9984 6.60623 21.9689 6.75142 21.9116C6.89662 21.8543 7.02849 21.7703 7.13948 21.6645L7.14237 19.1194H16.6002C21.9676 19.1194 23.1421 15.7616 23.1421 14.4155V12.9979C23.1421 11.8607 22.1701 11.0577 20.9725 11.0577Z",
  fill: "white"
});

var SvgIconRepeat = function SvgIconRepeat(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconRepeat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-repeat.f48bbe67.svg";
export { ForwardRef as ReactComponent };